export const selectGroupsAndServicesShortcutId = 'select-groups-and-services';
export const theKeyId = 'my-hub';
export const maxWashingLineLength = 50;

interface Shortcut {
  _id: string;
  name: string;
  icon: string;
  iconUrl: string | null;
  locked: boolean;
  linkedObject: null;
}

const newsShortcut: Shortcut = {
  _id: 'news',
  name: 'News',
  icon: 'chrome_reader_mode',
  iconUrl: null,
  locked: true,
  linkedObject: null,
};

export const getMyHubName = (firstName: string | null | undefined) => {
  return firstName ? firstName + "'s Hub" : 'My Hub';
};

const getMultiGroupViewShortcut = (firstName: string) => {
  const multiGroupViewShortcutName = getMyHubName(firstName);
  return {
    _id: theKeyId,
    name: multiGroupViewShortcutName,
    icon: 'home',
    iconUrl: null,
    locked: true,
    linkedObject: null,
  };
};

export const getSecondaryTextForIcon = (id: string | null | undefined) => {
  switch (id) {
    case selectGroupsAndServicesShortcutId:
      return 'This icon shows you all of your boards, groups and services on one page.';
    default:
      return undefined;
  }
};

export const getInitialShortcuts = (
  firstName: string,
  isMyHubEnabled: boolean,
) => {
  const initialShortcuts: Shortcut[] = [newsShortcut];

  if (isMyHubEnabled) {
    initialShortcuts.unshift(getMultiGroupViewShortcut(firstName));
  }

  return initialShortcuts;
};
